<template>
  <div class="detail-page">

    <!-- ===== 01. 메인 비주얼 ===== -->
    <section class="dp-hero">
      <img :src="require('@/assets/1.png')" alt="메인 비주얼" class="dp-hero-img" />
      <img :src="require('@/assets/2.png')" alt="메인 비주얼 2" class="dp-hero-img" />
    </section>

    <!-- ===== 사업개요 ===== -->
    <section class="sec sec-overview">
      <div class="sec-inner">
        <p class="sec-eyebrow">BUSINESS</p>
        <h2 class="section-title">사업개요</h2>
        <img :src="require('@/assets/3.jpg')" alt="사업개요" class="overview-img" />
        <dl class="overview-list">
          <div class="overview-row">
            <dt>사업위치</dt>
            <dd>경기도 김포시 풍무 1로 27 (풍무동 880번지)</dd>
          </div>
          <div class="overview-row">
            <dt>대지면적</dt>
            <dd>6,900㎡</dd>
          </div>
          <div class="overview-row">
            <dt>연면적</dt>
            <dd>51,902㎡</dd>
          </div>
          <div class="overview-row">
            <dt>건폐율 / 용적률</dt>
            <dd>59.63% / 461.62%</dd>
          </div>
          <div class="overview-row">
            <dt>건축규모</dt>
            <dd>지하 4층, 지상 10층 / 총 1개동 / 288실</dd>
          </div>
          <div class="overview-row">
            <dt>주차대수</dt>
            <dd>총 370대 중 오피스텔 310대 (호실당 1.07대)</dd>
          </div>
        </dl>
      </div>
    </section>

    <!-- ===== 프리미엄 6 ===== -->
    <section class="sec sec-premium8">
      <!-- 상단 헤드 배너 -->
      <div class="p8-banner">
        <span class="p8-corner p8-corner-tl"></span>
        <span class="p8-corner p8-corner-tr"></span>
        <span class="p8-corner p8-corner-bl"></span>
        <span class="p8-corner p8-corner-br"></span>
        <p class="p8-banner-text">
          <strong class="p8-accent">김포 풍무역 푸르지오 시티</strong>
          <span class="p8-banner-sep">-</span>
          <strong class="p8-banner-hl">가치를 다 누릴 프리미엄 레벨 6!</strong>
        </p>
      </div>

      <div class="p8-body">
        <!-- 좌측 브랜드 패널 -->
        <div class="p8-brand">
          <div class="p8-brand-arch">
            <p class="p8-brand-eyebrow">김포 풍무역 푸르지오</p>
            <p class="p8-brand-line">PREMIUM</p>
            <span class="p8-brand-bignum">6</span>
            <div class="p8-brand-divider"></div>
            <p class="p8-brand-name">김포 풍무역 푸르지오 시티</p>
          </div>
        </div>

        <!-- 우측 프리미엄 카드 그리드 -->
        <div class="p8-grid">
          <div class="p8-card" v-for="(item, idx) in premiumItems" :key="idx">
            <span class="p8-card-num">{{ String(idx + 1).padStart(2, '0') }}</span>
            <p class="p8-card-label">PREMIUM</p>
            <h3 class="p8-card-title" v-html="item.title"></h3>
            <div class="p8-card-divider"></div>
            <p class="p8-card-desc" v-html="item.desc"></p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 입지환경 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">LOCATION</p>
        <h2 class="section-title">입지환경</h2>
      </div>
      <img :src="require('@/assets/입지환경.jpg')" alt="입지환경" class="community-img" />
    </section>

    <!-- ===== 단지배치도 ===== -->
    <section class="sec sec-layout">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT LAYOUT</p>
        <h2 class="section-title">단지배치도</h2>
      </div>
      <img :src="require('@/assets/동호배치도1.jpg')" alt="단지배치도 1" class="layout-img" />
      <img :src="require('@/assets/동호배치도2.jpg')" alt="단지배치도 2" class="layout-img" />
    </section>

    <!-- ===== 세대정보 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT PLAN</p>
        <h2 class="section-title">세대정보</h2>

        <!-- 유닛 타입 탭 (가로 스크롤) -->
        <div class="unit-tabs-wrap">
          <div class="unit-tabs">
            <button
              v-for="tab in unitTabs"
              :key="tab.id"
              class="unit-tab"
              :class="{ active: activeUnit === tab.id }"
              @click="activeUnit = tab.id"
            >
              <span class="unit-tab-label">{{ tab.label }}</span>
              <span v-if="tab.tag" class="unit-tab-tag">{{ tab.tag }}</span>
            </button>
          </div>
        </div>

        <!-- 활성 유닛 라벨 -->
        <div class="unit-current">
          <span class="unit-current-name">{{ activeUnit }}</span>
          <span v-if="activeUnitTag" class="unit-current-tag">{{ activeUnitTag }}</span>
        </div>

        <!-- 평면 이미지 -->
        <transition name="fade" mode="out-in">
          <div class="unit-stack" :key="activeUnit">
            <figure class="unit-figure">
              <img :src="unitPlanImage" :alt="`${activeUnit} 평면도`" class="unit-img" />
            </figure>
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 기본제공품목 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">OPTIONS</p>
        <h2 class="section-title">기본제공품목</h2>
      </div>
      <img :src="require('@/assets/기본제공품목.jpg')" alt="기본제공품목" class="community-img" />
    </section>

    <!-- ===== 커뮤니티 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">COMMUNITY</p>
        <h2 class="section-title">커뮤니티</h2>
      </div>
      <img :src="require('@/assets/커뮤니티.jpg')" alt="커뮤니티" class="community-img" />
    </section>

    <!-- ===== 단지조경 -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">LANDSCAPE</p>
        <h2 class="section-title">단지조경</h2>
      </div>
      <img :src="require('@/assets/단지조경.jpg')" alt="단지조경" class="community-img" />
    </section>

    <!-- ===== 시스템 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">SYSTEM</p>
        <h2 class="section-title">시스템</h2>
      </div>
      <img :src="require('@/assets/시스템.png')" alt="시스템" class="community-img" />
    </section>

    <!-- ===== 10. 방문예약 ===== -->
    <section class="dp-register" ref="secRegister">
      <div class="dp-section-inner">
        <p class="dp-eyebrow light">CONTACT</p>
        <h2 class="dp-section-title light">방문예약</h2>
        <p class="dp-register-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

        <div v-if="!isSubmitted">
          <form @submit.prevent="submitForm" class="dp-form">
            <div class="dp-field">
              <label>이름 <span class="dp-req">*</span></label>
              <input type="text" v-model="formData.name" placeholder="이름을 입력해주세요" required />
            </div>
            <div class="dp-field">
              <label>연락처 <span class="dp-req">*</span></label>
              <div class="dp-phone">
                <input type="tel" inputmode="numeric" ref="p1" v-model="formData.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'p2')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="p2" v-model="formData.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'p3')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="p3" v-model="formData.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="dp-field">
              <label>관심 타입을 선택해주세요 <span class="dp-req">*</span></label>
              <div class="dp-interest-tabs">
                <button type="button" v-for="opt in interestOptions" :key="opt"
                        class="dp-interest-tab" :class="{ active: formData.interest === opt }"
                        @click="formData.interest = opt">{{ opt }}</button>
              </div>
            </div>
            <label class="dp-agree">
              <input type="checkbox" v-model="formData.agree" required />
              <span class="dp-check"></span>
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <button type="submit" class="dp-submit" :disabled="isSubmitting">
              {{ isSubmitting ? '전송 중...' : '방문예약 신청' }}
            </button>
          </form>
        </div>

        <div v-else class="dp-success">
          <div class="dp-success-icon">&#10003;</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MainView',
  data() {
    return {
      observers: [],
      activeUnit: '64A',
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        interest: '',
        agree: false
      },
      interestOptions: ['64㎡(19평)', '67㎡(20평)', '82㎡(25평)', '상담 먼저 받기'],
      unitTabs: [
        { id: '64A', label: '64A' },
        { id: '64B', label: '64B' },
        { id: '67A', label: '67A' },
        { id: '67B', label: '67B' },
        { id: '82A', label: '82A' },
        { id: '82B', label: '82B' }
      ],
      premiumItems: [
        {
          title: '5호선 연장선<br/>최대 수혜단지',
          desc: '5호선 연장선 예타 조사 통과'
        },
        {
          title: '지역개발의<br/>든든한 가치',
          desc: '인하대 김포메디컬캠퍼스(예정) 등'
        },
        {
          title: '실거주 · 투자자<br/>맞춤상품',
          desc: '선호도 높은 2Room 설계'
        },
        {
          title: '푸르지오 시티의<br/>자부심',
          desc: '프리미엄 브랜드 오피스텔'
        },
        {
          title: '다채로운<br/>생활 인프라',
          desc: '이마트 트레이더스, 홈플러스 등'
        },
        {
          title: '도심 속<br/>에코 프리미엄',
          desc: '단지 앞 선수공원 자연조망(일부)'
        }
      ]
    }
  },
  computed: {
    unitPlanImage() {
      return require(`@/assets/unit/${this.activeUnit}.jpg`)
    },
    activeUnitTag() {
      return this.unitTabs.find(t => t.id === this.activeUnit)?.tag || ''
    }
  },
  mounted() {
    this.setupObservers()
    setTimeout(() => {
      window.dispatchEvent(new Event('open-register-popup'))
    }, 1200)
  },
  beforeUnmount() {
    this.observers.forEach(ob => ob.disconnect())
  },
  methods: {
    setupObservers() {
      this.$nextTick(() => {
        const scenes = this.$el?.querySelectorAll('.story-scene') || []
        scenes.forEach((scene) => {
          const ob = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              scene.classList.add('show')
              ob.disconnect()
            }
          }, { threshold: 0.15 })
          ob.observe(scene)
          this.observers.push(ob)
        })
      })
    },
    scrollToForm() {
      this.$refs.secRegister?.scrollIntoView({ behavior: 'smooth' })
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.formData.interest) {
        alert('관심 타입을 선택해주세요.')
        return
      }
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          interest: this.formData.interest,
          source: 'website'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 'CHANGE_ME_NAVER_WCS'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 기본 ===== */
.detail-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #fff;
  overflow-x: hidden;
  padding-bottom: 120px;
}

.dp-section-inner {
  max-width: 560px;
  margin: 0 auto;
  padding: 72px 28px;
}

.dp-num {
  display: inline-block;
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 48px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.06);
  line-height: 1;
  margin-bottom: 8px;
}

.dp-num.light {
  color: rgba(255, 255, 255, 0.1);
}

.dp-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #1B4332;
  margin-bottom: 16px;
}

.dp-eyebrow.light {
  color: rgba(255, 255, 255, 0.4);
}

.dp-section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 1.5;
  margin-bottom: 40px;
}

.dp-section-title strong {
  font-weight: 800;
}

.dp-section-title.light {
  color: rgba(255, 255, 255, 0.6);
}

.dp-section-title.light strong {
  color: #fff;
}

/* ===== 01. 메인 비주얼 ===== */
.dp-hero {
  width: 100%;
  line-height: 0;
}

.dp-hero-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 02. 프로젝트 스토리 (5씬) ===== */
.dp-story {
  background: linear-gradient(180deg, #0D2A1E 0%, #1B4332 100%);
  padding: 80px 0 100px;
  position: relative;
  overflow: hidden;
}

.dp-story::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(circle at 15% 12%, rgba(255, 211, 107, 0.10), transparent 40%),
    radial-gradient(circle at 85% 88%, rgba(255, 211, 107, 0.06), transparent 40%);
  pointer-events: none;
}

/* -- 섹션 헤더 -- */
.story-hero {
  text-align: center;
  padding: 0 28px 56px;
  position: relative;
  z-index: 1;
}

.story-hero-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 6px;
  color: rgba(255, 211, 107, 0.85);
  margin-bottom: 24px;
}

.story-hero-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 38px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.3;
  margin-bottom: 28px;
  letter-spacing: -1px;
}

.story-hero-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #ffd36b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.story-hero-divider {
  width: 56px;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
  margin: 0 auto;
  border-radius: 2px;
}

/* -- 씬 카드 공통 -- */
.story-scene {
  position: relative;
  z-index: 1;
  max-width: 480px;
  margin: 24px auto;
  padding: 36px 28px;
  background: #fdfaf2;
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

@media (max-width: 520px) {
  .story-scene {
    margin: 20px 16px;
    padding: 28px 22px;
  }
}

.story-scene.show {
  opacity: 1;
  transform: translateY(0);
}

.scene-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(30, 58, 111, 0.12);
}

.scene-num {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: 900;
  color: #1B4332;
  line-height: 1;
}

.scene-eyebrow {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.scene-body {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  color: #2c2c2c;
}

.scene-body > * + * {
  margin-top: 18px;
}

.scene-body strong {
  font-weight: 800;
}

.scene-lead {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.6;
  color: #555;
}

.scene-lead strong {
  font-weight: 800;
  color: #1a1a1a;
}

.scene-pivot {
  font-size: 19px;
  font-weight: 800;
  color: #1B4332;
  text-align: center;
  letter-spacing: -0.5px;
}

.scene-emphasis {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  letter-spacing: -0.3px;
}

.scene-emphasis strong {
  color: #1B4332;
  font-weight: 900;
}

.scene-quote {
  font-size: 17px;
  font-weight: 700;
  color: #c9a14a;
  text-align: center;
  letter-spacing: -0.3px;
  padding-bottom: 8px;
}

.scene-quote strong {
  color: #ff5757;
  font-weight: 900;
}

.scene-ctx-line {
  text-align: center;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(30, 58, 111, 0.06) 0%, rgba(201, 161, 74, 0.08) 100%);
  border-radius: 10px;
  border-left: 3px solid #c9a14a;
}

.scene-finale {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  text-align: center;
  letter-spacing: -0.3px;
  padding: 16px;
  background: rgba(30, 58, 111, 0.05);
  border-radius: 10px;
}

.scene-finale strong {
  color: #1B4332;
  font-weight: 900;
}

/* SCENE 01: 10년 split */
.scene-split {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 12px;
  background: #fff;
  border: 1px solid rgba(30, 58, 111, 0.1);
  border-radius: 14px;
}

.split-item {
  flex: 1;
  text-align: center;
}

.split-num {
  display: block;
  font-family: 'Paperlogy', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #1B4332;
  line-height: 1.1;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.split-text {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  line-height: 1.5;
}

.split-text strong {
  font-weight: 900;
  color: #1a1a1a;
}

.split-divider {
  width: 1px;
  height: 56px;
  background: rgba(0, 0, 0, 0.1);
}

/* SCENE 02: 49층 빅넘 */
.scene-bignum {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  padding: 22px 12px;
  background: linear-gradient(135deg, #1B4332 0%, #0D2A1E 100%);
  border-radius: 14px;
  position: relative;
  overflow: hidden;
}

.scene-bignum::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
}

.bignum-prefix,
.bignum-suffix {
  font-size: 16px;
  font-weight: 700;
  color: rgba(255, 211, 107, 0.95);
}

.bignum-num {
  font-family: 'Paperlogy', sans-serif;
  font-size: 64px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
  letter-spacing: -2px;
  text-shadow: 0 2px 16px rgba(255, 211, 107, 0.35);
}

.bignum-unit {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-right: 6px;
}

/* 일반 리스트 */
.scene-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.scene-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #444;
  border-left: 3px solid #1B4332;
}

.scene-list li + li {
  margin-top: 10px;
}

.scene-list li strong {
  font-weight: 800;
  color: #1a1a1a;
}

.list-icon {
  font-size: 18px;
  flex-shrink: 0;
}

/* SCENE 03: 체크리스트 */
.scene-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(30, 58, 111, 0.08);
}

.scene-checklist li {
  position: relative;
  padding: 14px 16px 14px 46px;
  font-size: 15px;
  font-weight: 600;
  color: #2c2c2c;
  letter-spacing: -0.3px;
}

.scene-checklist li + li {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.scene-checklist li::before {
  content: '✓';
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: #1B4332;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scene-checklist li strong {
  color: #1B4332;
  font-weight: 900;
}

/* SCENE 04: 상품 그리드 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.product-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 6px;
  background: linear-gradient(135deg, #1B4332 0%, #2D6A4F 100%);
  border-radius: 12px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.product-pill::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
}

.pill-cat {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 211, 107, 0.95);
  letter-spacing: 1px;
}

.pill-area {
  font-family: 'Paperlogy', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #fff;
  letter-spacing: -1px;
}

.feature-row {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.feature-item {
  flex: 1;
  text-align: center;
  padding: 12px 8px;
  background: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
  color: #1B4332;
  border: 1px solid rgba(30, 58, 111, 0.15);
  letter-spacing: 1px;
}

/* SCENE 05: 마무리 + 혜택 */
.story-scene-final {
  background: linear-gradient(180deg, #fdfaf2 0%, #fff8e3 100%);
}

.scene-brand {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #1B4332;
  text-align: center;
  letter-spacing: -1px;
  padding: 16px 12px;
  border-top: 2px solid #1B4332;
  border-bottom: 2px solid #1B4332;
}

.benefit-card {
  background: #fff;
  border-radius: 14px;
  padding: 30px 20px 20px;
  position: relative;
  box-shadow: 0 4px 20px rgba(30, 58, 111, 0.08);
}

.benefit-ribbon {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ff5757, #ff8a3d);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  padding: 7px 18px;
  border-radius: 50px;
  letter-spacing: -0.3px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(255, 87, 87, 0.35);
}

.benefit-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.benefit-list li {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 4px;
  font-size: 16px;
  font-weight: 600;
  color: #2c2c2c;
}

.benefit-list li + li {
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.benefit-list li strong {
  font-weight: 900;
  color: #1B4332;
}

.benefit-icon {
  font-size: 22px;
  width: 28px;
  text-align: center;
  flex-shrink: 0;
}

.scene-warn {
  font-size: 16px;
  font-weight: 700;
  color: #555;
  text-align: center;
  line-height: 1.6;
}

.scene-warn strong {
  color: #ff5757;
  font-weight: 900;
}

.scene-cta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 32px;
  background: linear-gradient(135deg, #1B4332, #0D2A1E);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.3px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(30, 58, 111, 0.4);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.scene-cta:active {
  transform: scale(0.97);
}

.cta-arrow {
  font-size: 20px;
  font-weight: 900;
}

/* ===== 공통 sec / sec-inner ===== */
.sec { position: relative; }
.sec-inner { padding: 80px 28px; }

.sec-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--primary, #1B4332);
  margin-bottom: 20px;
}

.section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
  line-height: 1.4;
}

/* ===== 사업개요 ===== */
.sec-overview { background: #ffffff; }
.sec-overview .sec-inner { padding: 60px 28px; }

.overview-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  margin-bottom: 36px;
}

.overview-list {
  border-top: 2px solid var(--primary, #1B4332);
}

.overview-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 4px;
  border-bottom: 1px solid #e8e8e8;
}

.overview-row dt {
  flex: 0 0 92px;
  font-weight: 700;
  font-size: 14px;
  color: var(--primary, #1B4332);
  line-height: 1.5;
}

.overview-row dd {
  flex: 1;
  margin: 0;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: keep-all;
}

/* ===== PREMIUM 8 ===== */
.sec-premium8 {
  background: #fdfaf2;
  padding: 8px 0 60px;
}

/* 상단 헤드 배너 */
.p8-banner {
  position: relative;
  max-width: 920px;
  margin: 0 20px 36px;
  padding: 18px 28px;
  border: 1.5px solid #c9a14a;
  border-radius: 8px;
  text-align: center;
}

@media (min-width: 940px) {
  .p8-banner {
    margin-left: auto;
    margin-right: auto;
  }
}

.p8-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #fdfaf2;
}

.p8-corner-tl { top: -8px; left: 26px; transform: rotate(45deg); border-top: 1.5px solid #c9a14a; border-left: 1.5px solid #c9a14a; }
.p8-corner-tr { top: -8px; right: 26px; transform: rotate(45deg); border-top: 1.5px solid #c9a14a; border-right: 1.5px solid #c9a14a; }
.p8-corner-bl { bottom: -8px; left: 26px; transform: rotate(45deg); border-bottom: 1.5px solid #c9a14a; border-left: 1.5px solid #c9a14a; }
.p8-corner-br { bottom: -8px; right: 26px; transform: rotate(45deg); border-bottom: 1.5px solid #c9a14a; border-right: 1.5px solid #c9a14a; }

.p8-banner-text {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  line-height: 1.5;
  margin: 0;
}

.p8-accent {
  font-weight: 900;
  font-size: 1.05em;
}

.p8-banner-sep {
  display: inline-block;
  margin: 0 6px;
  color: #c9a14a;
}

.p8-banner-hl {
  font-weight: 900;
  color: #c9a14a;
}

@media (max-width: 520px) {
  .p8-banner {
    margin: 0 12px 28px;
    padding: 16px 18px;
  }
  .p8-banner-text {
    font-size: 14px;
  }
  .p8-corner-tl, .p8-corner-tr { top: -7px; }
  .p8-corner-bl, .p8-corner-br { bottom: -7px; }
}

/* 본문: 좌측 브랜드 + 우측 그리드 */
.p8-body {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 32px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 760px) {
  .p8-body {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 0 16px;
  }
}

/* 좌측 브랜드 패널 */
.p8-brand {
  position: relative;
  text-align: center;
  padding: 28px 16px;
}

.p8-brand-arch {
  position: relative;
  border: 1.5px solid #c9a14a;
  border-bottom: none;
  border-radius: 220px 220px 0 0;
  padding: 36px 16px 28px;
  min-height: 360px;
}

.p8-brand-arch::before,
.p8-brand-arch::after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 12px;
  height: 1.5px;
  background: #c9a14a;
}

.p8-brand-arch::before { left: -1.5px; }
.p8-brand-arch::after { right: -1.5px; }

.p8-brand-eyebrow {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 22px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  margin: 0 0 4px;
}

.p8-brand-line {
  font-family: 'Roboto', 'Paperlogy', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 4px;
  margin: 0 0 16px;
}

.p8-brand-bignum {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 140px;
  font-weight: 900;
  color: #c9a14a;
  line-height: 1;
  display: block;
  letter-spacing: -4px;
}

.p8-brand-divider {
  width: 1px;
  height: 28px;
  background: #c9a14a;
  margin: 24px auto 18px;
}

.p8-brand-finale {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.p8-brand-name {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: #1B4332;
  margin: 0;
  letter-spacing: -0.3px;
}

@media (max-width: 760px) {
  .p8-brand-arch {
    border-radius: 180px 180px 0 0;
    min-height: 320px;
    padding: 28px 16px 24px;
  }
  .p8-brand-bignum { font-size: 110px; }
}

/* 우측 카드 그리드 */
.p8-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 14px;
}

@media (max-width: 380px) {
  .p8-grid {
    grid-template-columns: 1fr;
  }
}

.p8-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 28px 22px 24px;
  background: #fff;
  border-radius: 4px;
  border-top: 2px solid #c9a14a;
  box-shadow: 0 4px 16px rgba(30, 58, 111, 0.05);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 200px;
}

.p8-card::before {
  content: '';
  position: absolute;
  bottom: -10px;
  right: -8px;
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(201, 161, 74, 0.08) 0%, transparent 70%);
  pointer-events: none;
}

.p8-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(30, 58, 111, 0.12);
}

.p8-card-num {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 56px;
  font-weight: 900;
  color: #c9a14a;
  line-height: 1;
  letter-spacing: -2px;
  margin-bottom: 4px;
  display: block;
}

.p8-card-label {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 3px;
  margin: 0 0 10px;
}

.p8-card-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 20px;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1.25;
  letter-spacing: -0.7px;
  margin: 0 0 12px;
}

.p8-card-divider {
  width: 28px;
  height: 2px;
  background: #c9a14a;
  margin-bottom: 14px;
  border-radius: 1px;
}

.p8-card-desc {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  color: #444;
  line-height: 1.65;
  letter-spacing: -0.3px;
  margin: 0;
  position: relative;
  z-index: 1;
}

@media (max-width: 520px) {
  .p8-card {
    padding: 22px 18px 20px;
    min-height: 170px;
  }
  .p8-card-num {
    font-size: 44px;
  }
  .p8-card-title {
    font-size: 17px;
  }
}

/* ===== 단지배치도 ===== */
.sec-layout { background: #fafaf7; }
.sec-layout .sec-inner { padding: 40px 28px 16px; }

.layout-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 세대정보 ===== */
.sec-unit { background: #fff; }
.sec-unit .sec-inner { padding: 40px 28px 28px; }

/* 유닛 탭 가로 스크롤 */
.unit-tabs-wrap {
  margin: 0 -28px 18px;
  padding: 0 28px 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.unit-tabs-wrap::-webkit-scrollbar { display: none; }

.unit-tabs {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding-right: 28px;
}

.unit-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #f5f5f5;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.unit-tab:hover { background: #ececec; }

.unit-tab.active {
  background: var(--primary, #1B4332);
  color: #fff;
  box-shadow: 0 6px 14px rgba(30, 58, 111, 0.25);
}

.unit-tab-tag {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: #c9a14a;
  color: #fff;
  letter-spacing: -0.2px;
}

.unit-tab.active .unit-tab-tag {
  background: #ffd36b;
  color: #1B4332;
}

/* 기본/옵션 세그먼트 토글 */
.unit-mode {
  display: inline-flex;
  background: #f0f0f0;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 16px;
}

.unit-mode-btn {
  padding: 9px 22px;
  background: transparent;
  border: none;
  border-radius: 999px;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #888;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: -0.3px;
}

.unit-mode-btn.active {
  background: #1a1a1a;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

/* 활성 유닛 라벨 */
.unit-current {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}

.unit-current-name {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: -1px;
}

.unit-current-tag {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
  background: #c9a14a;
  padding: 3px 8px;
  border-radius: 4px;
  letter-spacing: -0.2px;
}

.unit-current-mode {
  margin-left: auto;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #1B4332;
  background: rgba(30, 58, 111, 0.08);
  padding: 4px 10px;
  border-radius: 999px;
}

/* 평면도 + 디테일 스택 */
.unit-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.unit-figure {
  margin: 0;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
}

.unit-cap {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #888;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.unit-img {
  width: 100%;
  height: auto;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ===== 커뮤니티 ===== */
.sec-community { background: #fafaf7; }
.sec-community .sec-inner { padding: 40px 28px 16px; }

.community-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 10. 방문예약 ===== */
.dp-register {
  background: #1B4332;
}

.dp-register-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: -28px;
  margin-bottom: 36px;
}

.dp-form {
  max-width: 400px;
}

.dp-field {
  margin-bottom: 18px;
}

.dp-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.dp-req { color: #e8a0a0; }

.dp-field input[type="text"],
.dp-field input[type="tel"] {
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.dp-field input:focus { border-color: #fff; }
.dp-field input::placeholder { color: #bbb; }

.dp-phone {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dp-phone input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.dp-phone span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  flex-shrink: 0;
}

.dp-time-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.dp-date-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dp-date-wrap {
  position: relative;
  width: 100%;
}

.dp-date-input {
  width: 100%;
  padding: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  font-family: var(--font-family);
  font-size: 14px;
  outline: none;
  color-scheme: dark;
  cursor: pointer;
}

.dp-date-input:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-date-placeholder {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
  background: #1B4332;
  padding-right: 8px;
}

.dp-select {
  width: 100%;
  padding: 14px 36px 14px 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  font-family: var(--font-family);
  font-size: 14px;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23fff' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.dp-select:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-select option {
  background: #1B4332;
  color: #fff;
}

.dp-later-btn {
  margin-top: 10px;
  width: 100%;
  padding: 13px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-later-btn.active {
  background: #fff;
  border-style: solid;
  border-color: #fff;
  color: #1B4332;
  font-weight: 800;
}

/* 관심 타입 탭 (2x2, 진녹 배경용) */
.dp-interest-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.dp-interest-tab {
  padding: 15px 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-interest-tab.active {
  background: #fff;
  border-color: #fff;
  color: #1B4332;
  font-weight: 800;
}

.dp-time-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.dp-time-btn {
  padding: 12px 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-time-btn:hover { background: rgba(255, 255, 255, 0.14); }

.dp-time-btn.active {
  background: #fff;
  color: #1B4332;
  border-color: #fff;
  font-weight: 700;
}

.dp-visit { display: flex; gap: 8px; }

.dp-visit-wrap {
  flex: 1;
  position: relative;
}

.dp-visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.dp-visit input,
.dp-visit select {
  width: 100%;
  padding: 14px 16px 14px 40px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  appearance: none;
  transition: border-color 0.2s ease;
}

.dp-visit input:focus,
.dp-visit select:focus { border-color: #fff; }

.dp-visit select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.dp-agree {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 24px 0 20px;
}

.dp-agree input[type="checkbox"] { display: none; }

.dp-check {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.dp-agree input:checked + .dp-check {
  background: #fff;
  border-color: #fff;
}

.dp-agree input:checked + .dp-check::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #1B4332;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.dp-submit {
  width: 100%;
  padding: 16px;
  background: #fff;
  color: #1B4332;
  border: none;
  border-radius: 12px;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease;
}

.dp-submit:active { background: #e8e8e8; }
.dp-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.dp-success { text-align: center; padding: 40px 0; }

.dp-success-icon {
  width: 56px;
  height: 56px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  margin: 0 auto 16px;
}

.dp-success h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.dp-success p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

/* ===== 트리플 1초 역세권 ===== */
.sec-triple {
  background: linear-gradient(180deg, #0D2A1E 0%, #1B4332 100%);
  padding: 80px 0 90px;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.sec-triple::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(255, 211, 107, 0.12), transparent 45%),
    radial-gradient(circle at 80% 80%, rgba(255, 211, 107, 0.08), transparent 45%);
  pointer-events: none;
}

.triple-inner {
  position: relative;
  z-index: 1;
  max-width: 560px;
  margin: 0 auto;
  padding: 0 24px;
}

.triple-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 5px;
  color: rgba(255, 211, 107, 0.9);
  margin: 0 0 18px;
}

.triple-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 32px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: -1px;
  line-height: 1.3;
  margin: 0 0 18px;
}

.triple-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #ffd36b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.triple-divider {
  width: 56px;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
  margin: 0 auto 36px;
  border-radius: 2px;
}

.triple-img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto 32px;
  border-radius: 14px;
}

.triple-lines {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 32px;
}

.line-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 211, 107, 0.2);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
}

.line-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 8px 14px;
  font-weight: 900;
  font-size: 13px;
  border-radius: 20px;
  letter-spacing: -0.3px;
  white-space: nowrap;
}

.line-1 .line-badge { background: #0052a4; color: #fff; }
.line-2 .line-badge { background: #00a84d; color: #fff; }
.line-u .line-badge { background: #b0ce18; color: #1a1a1a; }

.line-name {
  font-size: 13px;
  font-weight: 800;
  color: #ffd36b;
  margin: 0 0 4px;
  letter-spacing: -0.3px;
}

.line-desc {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
  margin: 0;
}

.triple-hook {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 17px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  letter-spacing: -0.4px;
  margin: 0;
}

.triple-hook strong { font-weight: 800; color: #fff; }
.triple-hook .triple-hl { color: #ffd36b; font-weight: 900; }

@media (max-width: 480px) {
  .sec-triple { padding: 60px 0 70px; }
  .triple-title { font-size: 26px; }
  .triple-hook { font-size: 15px; }
  .line-badge { min-width: 72px; font-size: 12px; padding: 7px 10px; }
}

/* ===== 상품 그리드 2컬럼 변형 ===== */
.product-grid-2 { grid-template-columns: repeat(2, 1fr); }

/* ===== checklist tight (4번 씬 전용) ===== */
.scene-checklist-tight li {
  padding: 12px 16px 12px 42px;
  font-size: 14px;
}

</style>
